// The home page's notice at the foot of the screen (Oct 2026), with an Undo:
// a tile that goes when you mark it (a Top pick you asked to see less of, a
// Loved tune you took the heart off) says so here, since a stray tap on a
// small button should cost nothing. (A tune a card files into a playlist has
// the app's one notice for that, playlistAdded.ts, with Open and Undo.) One
// notice at a time: a new one replaces the last. Not a component, so the
// buttons and the toast can share it without a provider (react-refresh wants
// component files to export only components).

import { useSyncExternalStore } from 'react';

export interface HomeNotice {
  id: number;
  text: string;
  undo: () => void;
}

let current: HomeNotice | null = null;
let nextId = 1;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function showHomeNotice(text: string, undo: () => void): void {
  current = { id: nextId++, text, undo };
  emit();
}

/** Take the notice down; with an id, only if it is still the one showing. */
export function dismissHomeNotice(id?: number): void {
  if (!current || (id !== undefined && current.id !== id)) return;
  current = null;
  emit();
}

export function useHomeNotice(): HomeNotice | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
    () => null,
  );
}
